module.exports = __webpack_public_path__ + "img/DIVINOPOLIS - SETCOM.3e26bb23.png";